module.exports = __webpack_public_path__ + "img/2.80b9572a.png";